import { updateQlAfterNodeAdd } from 'containers/QuestionnaireLogic/utils';
import { defaultPristineValues } from 'utils/questionHelpers';
import { isEmpty } from 'lodash';
import { getNodesOnAdd, getNodeErrors } from '../utils';

export default function addNodeToList({
  nodes,
  node,
  refId,
  errors,
  scroll,
  offset,
  questionnaireLogic,
  screeningQuestions,
  surveyConfig,
  screenerTypes,
}) {
  const { groupRefId } = node;
  const nodeToAdd = {
    ...node,
    scrollIntoView: scroll ? Date.now() : undefined,
    pristineValues: defaultPristineValues(true, node.type),
  };

  if (nodeToAdd.questions) {
    nodeToAdd.questions = nodeToAdd.questions.map((question) => ({
      ...question,
      pristineValues: defaultPristineValues(),
    }));
  }

  const { newNodes, newNode } = getNodesOnAdd(
    nodes,
    refId,
    groupRefId,
    nodeToAdd,
    offset,
  );

  const newQuestionnaireLogic = updateQlAfterNodeAdd({
    questionnaireLogic,
    node,
    refId,
    offset,
    screenerTypes,
  });
  const {
    previousNodesPerNode,
    answersWithLogicFromOutcomes,
    answersWithLogicFromOutcomesHide,
    nodesWithLogicFromOutcomesShow,
    hiddenNodes,
  } = newQuestionnaireLogic;

  const questionErrors = getNodeErrors({
    node: newNode,
    nodes,
    screeningQuestions,
    previousNodesPerNode,
    answersWithLogicFromOutcomes,
    answersWithLogicFromOutcomesHide,
    nodesWithLogicFromOutcomesShow,
    hiddenNodes,
    surveyConfig,
  });

  const globalErrors = [...errors];
  if (!isEmpty(questionErrors)) {
    globalErrors.push({
      questionRefId: newNode.refId,
      groupRefId: newNode.groupRefId,
      errors: questionErrors,
    });
  }

  return { newNodes, newQuestionnaireLogic, globalErrors };
}
